module.exports = require('lodash').merge